var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import DialogContent from "./DialogContent";
import DialogFooter from "./DialogFooter";
import Modal from "../modal/Modal";
import Flex from "../box/Flex";
import { apolloSpaceInset3X } from "@nexthink/apollo-tokens";
import DialogHeader from "./DialogHeader";
import useUniqueId from "../../hooks/useUniqueId";
import useAccessibleContainer from "../container/useAccessibleContainer";
const prefixId = "nx-dialog-";
const Dialog = (_a) => {
    var { width, height, header, actions, leftSection, children, isOpen, displayCloseIcon = false, id, "data-insights": insightsAttr, onClose, error, closeOnClickOutside = false } = _a, rest = __rest(_a, ["width", "height", "header", "actions", "leftSection", "children", "isOpen", "displayCloseIcon", "id", "data-insights", "onClose", "error", "closeOnClickOutside"]);
    id = useUniqueId(prefixId, id);
    const [containerRef, setContainerRef] = useState(null);
    const accessibleContainerProps = useAccessibleContainer(containerRef);
    return (React.createElement(Modal, Object.assign({ id: id, "data-insights": insightsAttr, width: width, height: height, isOpen: isOpen, displayCloseIcon: displayCloseIcon, onClose: onClose, closeOnClickOutside: closeOnClickOutside }, rest),
        React.createElement(Flex, { flexDirection: "column", flexGrow: 1, flexShrink: 1, width: "100%" },
            React.createElement(DialogHeader, { id: `${id}-header`, "data-insights": insightsAttr && `${insightsAttr}-header`, hasLeftSection: Boolean(leftSection) }, header),
            React.createElement(Flex, { flexGrow: 1, flexShrink: 1, height: "100%", overflow: "hidden" },
                leftSection && (React.createElement(Flex, { flexGrow: 0, flexShrink: 0, flexBasis: "auto" }, leftSection)),
                React.createElement(Flex, { flexDirection: "column", flexGrow: 1, flexShrink: 1, px: apolloSpaceInset3X, pt: apolloSpaceInset3X, width: "100%", overflow: "hidden" },
                    React.createElement(DialogContent, Object.assign({ id: `${id}-content`, "data-insights": insightsAttr && `${insightsAttr}-content`, ref: setContainerRef }, accessibleContainerProps), children),
                    React.createElement(DialogFooter, { id: `${id}-footer`, "data-insights": insightsAttr && `${insightsAttr}-footer`, actions: actions, message: error }))))));
};
export default Dialog;
//# sourceMappingURL=Dialog.js.map